import React, { useState } from 'react';
import { formatDateTime } from '../../common/formatDateText';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import {
    getAllRequestInvoice,
    getRequestInvoiceDetails,
    requestInvoiceApproved,
} from '../../redux/actions/request';
// import {
//     getTotalRequestStudentsPending
// } from '../../redux/actions/analytics';
import { onlyInvoice } from '../../static/data';
import { getTotalRequestInvoicePending } from '../../redux/actions/analytics';
import { DrawerDetailsPayment } from './DrawerDetailsPayment';

export const CardRequestInvoice = ({
    id,
    numberRequest,
    approvedBy,
    requestBy,
    requestDate,
    requestStatus,
    payment,
    setFilterOption
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);

    const { _id: userId, typeUser } = user;

    const [isOpenDrawerFilters, setIsOpenDrawerFilters] = useState(false);


    const handleShowDetails = (id) => {
        dispatch(getRequestInvoiceDetails(id));
        toggleDrawerFilters();
    }

    const handleConfirm = (id, requestType) => {
        dispatch(requestInvoiceApproved(id, userId))
            .then((response) => {
                if (response?.status === 200) {
                    toast.success(response?.message);
                    setFilterOption('pending');
                    dispatch(getAllRequestInvoice());
                    dispatch(getTotalRequestInvoicePending('pending'));
                }
            })
            .catch((error) => {
                toast.error('Error al confirmar la solicitud');
            });
    };

    const toggleDrawerFilters = () => {
        setIsOpenDrawerFilters((prevState) => !prevState);
    }


    return (
        <div className='w-full border border-gray-200 rounded-md shadow-sm bg-white'>
            <div className='w-full flex justify-between items-center p-4'>
                <div>
                    <p className='pt-2 px-1 text-[.9rem] font-semibold'>{`Solicitud #${numberRequest}`}</p>
                </div>
                <div>
                    <span className={`${requestStatus === 'done' ? 'bg-green-200' : requestStatus === 'pending' ? 'bg-orange-200' : 'bg-red-200'} rounded-md px-2.5 py-1.5 text-[.7rem]`}>
                        {
                            requestStatus === "pending"
                                ? <span className='text-orange-600'>Pendiente</span> : requestStatus === "done"
                                    ? <span className='text-green-600'>Completada</span> : <span className='text-red-600'>Rechazada</span>
                        }
                    </span>
                </div>
            </div>
            <div className='w-full flex flex-col gap-4 p-4'>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Solicitado por</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{
                        `[ ${requestBy?.matricula} ]`
                    }</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>
                        {`${requestBy?.firstName} ${requestBy?.secondName ? requestBy?.secondName : ''} ${requestBy?.lastName} ${requestBy?.secondSurname ? requestBy?.secondSurname : ''}`}
                    </span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Fecha de solicitud</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{formatDateTime(requestDate)}</span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Nombre cuenta</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center mb-1'>{
                        `${payment.account?.nameAccount}`
                    }</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>
                        {`${payment.account?.numberAccount}`}
                    </span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Monto</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{`$ ${payment.amount}`}</span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Aprobada por</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>
                        {approvedBy ? `${approvedBy?.firstName} ${approvedBy?.secondName ? approvedBy?.secondName : ''} ${approvedBy?.lastName} ${approvedBy?.secondSurname ? approvedBy?.secondSurname : ''}` : '-'}
                    </span>
                </div>
            </div>
            <div className='w-full flex flex-col md:flex-row justify-end p-4 gap-4'>
                <button
                    type='button'
                    onClick={() => handleShowDetails(id)}
                    className='rounded-md font-semibold text-md text-white bg-sky-600 hover:bg-sky-700 px-4 py-2'
                >Detalle</button>

                {
                    (requestStatus === 'pending' && onlyInvoice.includes(typeUser)) && (
                        <button
                            type='button'
                            onClick={() => handleConfirm(id)}
                            className='rounded-md font-semibold text-md text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2'
                        >Confirmar</button>
                    )
                }
            </div>
            <DrawerDetailsPayment
                isOpenDrawerFilters={isOpenDrawerFilters}
                toggleDrawerFilters={toggleDrawerFilters}
            />
        </div>
    )
}
